import styled from 'styled-components';
import SActionIcon from '@/presentation/actionIcon/ActionIcon.styled';

export const SStickyBarWrapper = styled.div`
  --stickyBarHeight: 60px;

  bottom: calc(var(--stickyBarHeight) * -1 - 10px);
  display: flex;
  left: 10px;
  position: absolute;
  right: 10px;

  > div {
    align-items: center;
    background: ${({ theme }) => theme.colors.quaternaryBackground};
    border-radius: 5px;
    box-shadow: 0px 1.5px 4px 0px rgba(${({ theme }) => theme.colors.primaryTextRGB}, 0.11),
      0px 7px 15px 0px rgba(${({ theme }) => theme.colors.primaryTextRGB}, 0.13);
    display: flex;
    min-height: var(--stickyBarHeight);

    + div {
      margin-left: 20px;
    }

    &.trashbin-actions {
      padding: 0 20px; // TODO: once circular buttons are implemented, improve this
    }
  }
`;

const SStickyBar = styled.div`
  flex: 1 1 100%;
  justify-content: space-between;
  padding: 0 20px;

  button + button,
  a + a {
    margin-left: 20px;
  }

  > div > div > div + div,
  ${SActionIcon} + ${SActionIcon} {
    margin-left: 10px;
  }

  .selected-items,
  .actions-buttons,
  .actions-buttons > div {
    align-items: center;
    display: flex;
    min-height: var(--stickyBarHeight);
  }

  .selected-items p + a {
    margin-left: 30px;
  }

  .actions-buttons > div {
    border-left: 1px solid ${({ theme }) => theme.colors.tertiaryBackground};
    padding-left: 40px;

    + div {
      margin-left: 40px;
    }
  }

  &.has-selected-items {
    background: ${({ theme }) => theme.colors.primaryText};

    p,
    span {
      color: ${({ theme }) => theme.colors.quaternaryBackground};
    }

    .actions-buttons > div {
      border-color: ${({ theme }) => theme.colors.secondaryText};
    }
  }
`;

export default SStickyBar;
